import React from "react";

type CardProps = {
  children?: React.ReactNode;
};
const Card = ({ children }: CardProps) => (
  <div className="bg-white w-full max-w-md rounded-lg shadow-lg p-8 py-12 flex flex-col space-y-6">{children}</div>
);

export default Card;
